import React, { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip'; 
import { FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function Minorias(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [minorias, setMinorias] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => EditarMinoria(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaUsers/>
                    </button>
                </div>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Minoria', selector: row => row.minMinoria, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.minActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/listarminorias';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setMinorias(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function EditarMinoria (row){
        setMuestraFormulario(true);
        setValue('Nuevo', false);
        setValue('id', row.id);
        setValue('minMinoria', row.minMinoria);
        setValue('minActivo', row.minActivo);
    };
    const NuevoMinoria = () =>  {
        setValue('Nuevo', true);
        setValue('id', 0);
        setValue('minMinoria', '');
        setValue('minActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarminoria';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar Minoria', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar Minoria', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar Minoria', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('Nuevo', true);
        setValue('id', 0);
        setValue('minMinoria', '');
        setValue('minActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Minoria</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={"/"} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={"/parametros"} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Minorias</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('Nuevo')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='minMinoria'>Minoria</label>
                                                <input id='minMinoria' {...register('minMinoria', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Minoria"/>
                                                {errors.minMinoria && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('minActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button className='form-control' onClick={NuevoMinoria}>Nuevo</button>
                                <DataTable
                                    title="Minorias"
                                    columns={columns}
                                    data={minorias}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}